import * as React from 'react';

import {
  enumSalesLoadLineItemPhase,
  SalesLoadLineItemPhase,
} from '@rematter/frontend-lib-api-client';
import { Toggle, ToggleButtonGroup } from '@rematter/ui-web';
import { useAtom } from 'jotai/react';
import { LucideMonitor, LucideWeight } from 'lucide-react';

import { $loadMaterialsStatus } from '~/modules/trade/_state/loadForm.state';
import { useTranslations } from '~/modules/trade/i18n/useTranslations';

export const LoadPhaseToggle: React.FC = () => {
  const t = useTranslations();

  const [loadMaterialsStatus, setLoadMaterialsStatus] =
    useAtom($loadMaterialsStatus);

  const handleViewModeChange = React.useCallback(
    (newViewMode: SalesLoadLineItemPhase) => {
      setLoadMaterialsStatus(newViewMode);
    },
    [setLoadMaterialsStatus],
  );

  return (
    <ToggleButtonGroup
      selectionMode="single"
      selectedKeys={
        loadMaterialsStatus
          ? [loadMaterialsStatus]
          : [enumSalesLoadLineItemPhase.Requested]
      }
      onSelectionChange={(v) => {
        const selection = Array.from(v.values());
        if (selection.length > 0) {
          handleViewModeChange(selection[0] as SalesLoadLineItemPhase);
        }
      }}
      className="@LoadPhaseToggle"
    >
      <Toggle id={enumSalesLoadLineItemPhase.Requested}>
        <div className="flex flex-row items-center gap-2">
          <LucideMonitor className="size-4" strokeWidth={1.5} />{' '}
          {t.loadsView.form.loadStatus.request}
        </div>
      </Toggle>
      <Toggle id={enumSalesLoadLineItemPhase.Staged}>
        <div className="flex flex-row items-center gap-2">
          <LucideWeight className="size-4" strokeWidth={1.5} />{' '}
          {t.loadsView.form.loadStatus.stage}
        </div>
      </Toggle>
    </ToggleButtonGroup>
  );
};
